<template>
  <svg
    width="6"
    height="12"
    viewBox="0 0 6 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.707107 6.70711L6 12L6 0L0.707107 5.29289C0.316582 5.68342 0.316583 6.31658 0.707107 6.70711Z"
      fill="currentColor"
    />
  </svg>
</template>
